/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Full API CRUD access to Contract entities.
 */
export const ContractsListQueryParams = zod.object({
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.'),
  "portfolio": zod.array(zod.string().uuid()).optional(),
  "property": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string().nullable()).optional(),
  "service_provider": zod.array(zod.string().uuid()).optional()
})

export const contractsListResponseResultsItemNameMax = 255;

export const contractsListResponseResultsItemAttachmentsItemPageNumberMin = -2147483648;
export const contractsListResponseResultsItemAttachmentsItemPageNumberMax = 2147483647;

export const contractsListResponseResultsItemServiceProviderOneOwnerOneUsernameMax = 150;


export const contractsListResponseResultsItemServiceProviderOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const contractsListResponseResultsItemServiceProviderOneOwnerOneEmailMax = 254;

export const contractsListResponseResultsItemServiceProviderOneOwnerOnePhoneNumberMax = 128;

export const contractsListResponseResultsItemPropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemPropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemPropertyContractsItemCarsItemMaintenanceTimePeriodMax = 2147483647;

export const contractsListResponseResultsItemPropertyContractsItemCarsItemRegularCallbackRateMax = 2147483647;

export const contractsListResponseResultsItemPropertyContractsItemCarsItemEmergencyCallbackRateMax = 2147483647;

export const contractsListResponseResultsItemPropertyContractsItemCarsItemRegularCallbackResponseTimeMax = 2147483647;

export const contractsListResponseResultsItemPropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax = 2147483647;

export const contractsListResponseResultsItemTermMax = 50;

export const contractsListResponseResultsItemPartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemCancellationMax = 255;

export const contractsListResponseResultsItemMaintenanceCompletionTargetMin = 0;
export const contractsListResponseResultsItemMaintenanceCompletionTargetMax = 2147483647;

export const contractsListResponseResultsItemMaintenanceHoursTargetMin = 0;
export const contractsListResponseResultsItemMaintenanceHoursTargetMax = 2147483647;

export const contractsListResponseResultsItemUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemEmergencyCallRateTargetMin = 0;
export const contractsListResponseResultsItemEmergencyCallRateTargetMax = 2147483647;

export const contractsListResponseResultsItemCallbackRateTargetMin = 0;
export const contractsListResponseResultsItemCallbackRateTargetMax = 2147483647;

export const contractsListResponseResultsItemHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemAnnualEscalationRateRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,4})?$');
export const contractsListResponseResultsItemReviewRulesItemCategoryDefault = `review-rule`;
export const contractsListResponseResultsItemRateSetsItemNameMax = 255;

export const contractsListResponseResultsItemRateSetsItemDescriptionMax = 255;

export const contractsListResponseResultsItemRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsListResponseResultsItemRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsListResponseResultsItemRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsListResponseResultsItemRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const ContractsListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsListResponseResultsItemNameMax),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "name": zod.string(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "pageNumber": zod.number().min(contractsListResponseResultsItemAttachmentsItemPageNumberMin).max(contractsListResponseResultsItemAttachmentsItemPageNumberMax).nullish(),
  "isSummarySheet": zod.boolean().optional(),
  "kind": zod.enum(['user_upload', 'cfi_report']).describe('\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report').optional().describe('What this attachment represents on the contract. user_upload is anything a user (or upstream pipeline) attaches; cfi_report marks a Contract Favorability Index PDF generated by the agent.\n\n\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report'),
  "uploadedAt": zod.string().datetime({"offset":true}),
  "hasTextLayer": zod.boolean()
}).strict()),
  "serviceProvider": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(contractsListResponseResultsItemServiceProviderOneOwnerOneUsernameMax).regex(contractsListResponseResultsItemServiceProviderOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(contractsListResponseResultsItemServiceProviderOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(contractsListResponseResultsItemServiceProviderOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "propertyAddress": zod.string().nullable(),
  "monthlyPrice": zod.string().regex(contractsListResponseResultsItemPropertyContractsItemMonthlyPriceRegExp).nullish().describe('Monthly price specific to this property under this contract'),
  "startDate": zod.string().date().nullish().describe('Start date for this specific property under the contract'),
  "expirationDate": zod.string().date().nullish().describe('Expiration date for this specific property under the contract'),
  "rateSet": zod.string().uuid().nullish(),
  "contractId": zod.string().uuid(),
  "rateSetId": zod.string().uuid().nullable(),
  "carCount": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "carId": zod.string().uuid(),
  "name": zod.string(),
  "maintenanceQuantity": zod.string().regex(contractsListResponseResultsItemPropertyContractsItemCarsItemMaintenanceQuantityRegExp).optional().describe('The target quantity for this KPI'),
  "maintenanceUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours').optional().describe('The unit of measurement for this KPI (visits or hours)\n\n\* `visits` - Visits\n\* `hours` - Hours'),
  "maintenanceTimePeriod": zod.number().min(1).max(contractsListResponseResultsItemPropertyContractsItemCarsItemMaintenanceTimePeriodMax).optional().describe('The time period in months over which this KPI target should be met'),
  "regularCallbackRate": zod.number().min(1).max(contractsListResponseResultsItemPropertyContractsItemCarsItemRegularCallbackRateMax).optional().describe('The target regular callback rate'),
  "emergencyCallbackRate": zod.number().min(1).max(contractsListResponseResultsItemPropertyContractsItemCarsItemEmergencyCallbackRateMax).optional().describe('The target emergency callback rate'),
  "regularCallbackResponseTime": zod.number().min(1).max(contractsListResponseResultsItemPropertyContractsItemCarsItemRegularCallbackResponseTimeMax).optional().describe('The target regular callback response time in minutes'),
  "emergencyCallbackResponseTime": zod.number().min(1).max(contractsListResponseResultsItemPropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax).optional().describe('The target emergency callback response time in minutes')
}).strict())
}).strict()),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsListResponseResultsItemTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "contractPaper": zod.string(),
  "businessHours": zod.string().nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "fireService": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsListResponseResultsItemPartsAndMaterialsMarkupRegExp).nullish(),
  "cancellation": zod.string().max(contractsListResponseResultsItemCancellationMax).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsListResponseResultsItemMaintenanceCompletionTargetMin).max(contractsListResponseResultsItemMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsListResponseResultsItemMaintenanceHoursTargetMin).max(contractsListResponseResultsItemMaintenanceHoursTargetMax).nullish(),
  "uptimeTarget": zod.string().regex(contractsListResponseResultsItemUptimeTargetRegExp).nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsListResponseResultsItemOnTimeResponseTimeTargetPctRegExp).nullish(),
  "emergencyCallRateTarget": zod.number().min(contractsListResponseResultsItemEmergencyCallRateTargetMin).max(contractsListResponseResultsItemEmergencyCallRateTargetMax).nullish(),
  "callbackRateTarget": zod.number().min(contractsListResponseResultsItemCallbackRateTargetMin).max(contractsListResponseResultsItemCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsListResponseResultsItemHourlyFeeAdjustmentRateRegExp).nullish(),
  "annualEscalationRate": zod.string().regex(contractsListResponseResultsItemAnnualEscalationRateRegExp).nullable().describe('Compound annual escalation rate as decimal (0.03 = 3%)'),
  "monthlyPricingTaxInclusive": zod.boolean().nullable().describe('Whether monthly pricing is tax-inclusive (null = unknown)'),
  "extractionVersion": zod.string().nullable().describe('Extraction pipeline version: null=pre-pipeline, \'v0\'=original 10-page, \'v1\'=enhanced agentic'),
  "extractionAppliedAt": zod.string().datetime({"offset":true}).nullable().describe('Timestamp of the most recent successful run of apply_extraction_to_existing_contract on this contract. NULL means the contract has never been processed by the extraction-rescue helper.'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string(),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsListResponseResultsItemReviewRulesItemCategoryDefault)
}).strict().describe('Serializer for contract review rule items in contract creation and update')),
  "notes": zod.string().nullish(),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "cars": zod.number(),
  "canChat": zod.boolean(),
  "aiReviewEligible": zod.boolean(),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsListResponseResultsItemRateSetsItemNameMax),
  "description": zod.string().max(contractsListResponseResultsItemRateSetsItemDescriptionMax).optional(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}),
  "rates": zod.array(zod.object({
  "id": zod.string().uuid(),
  "workType": zod.string(),
  "workerType": zod.string(),
  "rateType": zod.string(),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsListResponseResultsItemRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsListResponseResultsItemRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsListResponseResultsItemRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsListResponseResultsItemRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
}).strict()).optional()
}).strict())
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])'))
}).strict()

/**
 * Create a new contract and return the full contract data.
 *
 * The default schema would type the 201 body as ``ContractWrite`` (the
 * request serializer); declare the read serializer so the SDK gets the
 * full ``Contract`` this actually returns.
 */
export const contractsCreateBodyAttachmentsItemIsPrimaryDefault = false;
export const contractsCreateBodyAttachmentsItemIsSummarySheetDefault = false;
export const contractsCreateBodyCallbackRateTargetMin = 0;
export const contractsCreateBodyCallbackRateTargetMax = 2147483647;

export const contractsCreateBodyCancellationMax = 255;

export const contractsCreateBodyContractPaperMax = 255;

export const contractsCreateBodyEmergencyCallRateTargetMin = 0;
export const contractsCreateBodyEmergencyCallRateTargetMax = 2147483647;

export const contractsCreateBodyHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateBodyMaintenanceCompletionTargetMin = 0;
export const contractsCreateBodyMaintenanceCompletionTargetMax = 2147483647;

export const contractsCreateBodyMaintenanceHoursTargetMin = 0;
export const contractsCreateBodyMaintenanceHoursTargetMax = 2147483647;

export const contractsCreateBodyNameMax = 255;

export const contractsCreateBodyOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateBodyPartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateBodyPropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsCreateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsCreateBodyRateSetsItemNameMax = 255;

export const contractsCreateBodyRateSetsItemDescriptionMax = 255;




export const contractsCreateBodyRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsCreateBodyRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsCreateBodyRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsCreateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsCreateBodyReviewRulesItemCategoryDefault = `review-rule`;
export const contractsCreateBodyTermMax = 50;

export const contractsCreateBodyUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');


export const ContractsCreateBody = zod.object({
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "isPrimary": zod.boolean().default(contractsCreateBodyAttachmentsItemIsPrimaryDefault),
  "pageNumber": zod.number().nullish(),
  "isSummarySheet": zod.boolean().default(contractsCreateBodyAttachmentsItemIsSummarySheetDefault)
}).describe('Serializer for attachment data in contract creation')).optional().describe('List of attachments with their properties to associate with this contract'),
  "businessHours": zod.string().nullish(),
  "callbackRateTarget": zod.number().min(contractsCreateBodyCallbackRateTargetMin).max(contractsCreateBodyCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "cancellation": zod.string().max(contractsCreateBodyCancellationMax).nullish(),
  "contractPaper": zod.string().min(1).max(contractsCreateBodyContractPaperMax),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "emergencyCallRateTarget": zod.number().min(contractsCreateBodyEmergencyCallRateTargetMin).max(contractsCreateBodyEmergencyCallRateTargetMax).nullish(),
  "expirationDate": zod.string().date().nullish(),
  "fireService": zod.boolean().nullish(),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsCreateBodyHourlyFeeAdjustmentRateRegExp).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsCreateBodyMaintenanceCompletionTargetMin).max(contractsCreateBodyMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsCreateBodyMaintenanceHoursTargetMin).max(contractsCreateBodyMaintenanceHoursTargetMax).nullish(),
  "name": zod.string().min(1).max(contractsCreateBodyNameMax),
  "notes": zod.string().nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsCreateBodyOnTimeResponseTimeTargetPctRegExp).nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsCreateBodyPartsAndMaterialsMarkupRegExp).nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(contractsCreateBodyPropertyContractsItemMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(contractsCreateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})).optional().describe('Property contracts to create or update with this contract'),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1).max(contractsCreateBodyRateSetsItemNameMax),
  "description": zod.string().max(contractsCreateBodyRateSetsItemDescriptionMax).optional(),
  "isNew": zod.boolean(),
  "rates": zod.array(zod.object({
  "workType": zod.string().min(1),
  "workerType": zod.string().min(1),
  "rateType": zod.string().min(1),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsCreateBodyRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsCreateBodyRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsCreateBodyRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsCreateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
})).optional()
})).optional().describe('Rate sets to create with this contract'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string().min(1),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsCreateBodyReviewRulesItemCategoryDefault)
}).describe('Serializer for contract review rule items in contract creation and update')).optional().describe('Review rules to create with this contract'),
  "serviceProvider": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsCreateBodyTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "uptimeTarget": zod.string().regex(contractsCreateBodyUptimeTargetRegExp).nullish()
}).describe('Serializer for creating and updating contracts')

export const contractsCreateResponseNameMax = 255;

export const contractsCreateResponseAttachmentsItemPageNumberMin = -2147483648;
export const contractsCreateResponseAttachmentsItemPageNumberMax = 2147483647;

export const contractsCreateResponseServiceProviderOneOwnerOneUsernameMax = 150;


export const contractsCreateResponseServiceProviderOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const contractsCreateResponseServiceProviderOneOwnerOneEmailMax = 254;

export const contractsCreateResponseServiceProviderOneOwnerOnePhoneNumberMax = 128;

export const contractsCreateResponsePropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const contractsCreateResponsePropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');
export const contractsCreateResponsePropertyContractsItemCarsItemMaintenanceTimePeriodMax = 2147483647;

export const contractsCreateResponsePropertyContractsItemCarsItemRegularCallbackRateMax = 2147483647;

export const contractsCreateResponsePropertyContractsItemCarsItemEmergencyCallbackRateMax = 2147483647;

export const contractsCreateResponsePropertyContractsItemCarsItemRegularCallbackResponseTimeMax = 2147483647;

export const contractsCreateResponsePropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax = 2147483647;

export const contractsCreateResponseTermMax = 50;

export const contractsCreateResponsePartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateResponseCancellationMax = 255;

export const contractsCreateResponseMaintenanceCompletionTargetMin = 0;
export const contractsCreateResponseMaintenanceCompletionTargetMax = 2147483647;

export const contractsCreateResponseMaintenanceHoursTargetMin = 0;
export const contractsCreateResponseMaintenanceHoursTargetMax = 2147483647;

export const contractsCreateResponseUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateResponseOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateResponseEmergencyCallRateTargetMin = 0;
export const contractsCreateResponseEmergencyCallRateTargetMax = 2147483647;

export const contractsCreateResponseCallbackRateTargetMin = 0;
export const contractsCreateResponseCallbackRateTargetMax = 2147483647;

export const contractsCreateResponseHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsCreateResponseAnnualEscalationRateRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,4})?$');
export const contractsCreateResponseReviewRulesItemCategoryDefault = `review-rule`;
export const contractsCreateResponseRateSetsItemNameMax = 255;

export const contractsCreateResponseRateSetsItemDescriptionMax = 255;

export const contractsCreateResponseRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsCreateResponseRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsCreateResponseRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsCreateResponseRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const ContractsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsCreateResponseNameMax),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "name": zod.string(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "pageNumber": zod.number().min(contractsCreateResponseAttachmentsItemPageNumberMin).max(contractsCreateResponseAttachmentsItemPageNumberMax).nullish(),
  "isSummarySheet": zod.boolean().optional(),
  "kind": zod.enum(['user_upload', 'cfi_report']).describe('\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report').optional().describe('What this attachment represents on the contract. user_upload is anything a user (or upstream pipeline) attaches; cfi_report marks a Contract Favorability Index PDF generated by the agent.\n\n\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report'),
  "uploadedAt": zod.string().datetime({"offset":true}),
  "hasTextLayer": zod.boolean()
}).strict()),
  "serviceProvider": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(contractsCreateResponseServiceProviderOneOwnerOneUsernameMax).regex(contractsCreateResponseServiceProviderOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(contractsCreateResponseServiceProviderOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(contractsCreateResponseServiceProviderOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "propertyAddress": zod.string().nullable(),
  "monthlyPrice": zod.string().regex(contractsCreateResponsePropertyContractsItemMonthlyPriceRegExp).nullish().describe('Monthly price specific to this property under this contract'),
  "startDate": zod.string().date().nullish().describe('Start date for this specific property under the contract'),
  "expirationDate": zod.string().date().nullish().describe('Expiration date for this specific property under the contract'),
  "rateSet": zod.string().uuid().nullish(),
  "contractId": zod.string().uuid(),
  "rateSetId": zod.string().uuid().nullable(),
  "carCount": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "carId": zod.string().uuid(),
  "name": zod.string(),
  "maintenanceQuantity": zod.string().regex(contractsCreateResponsePropertyContractsItemCarsItemMaintenanceQuantityRegExp).optional().describe('The target quantity for this KPI'),
  "maintenanceUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours').optional().describe('The unit of measurement for this KPI (visits or hours)\n\n\* `visits` - Visits\n\* `hours` - Hours'),
  "maintenanceTimePeriod": zod.number().min(1).max(contractsCreateResponsePropertyContractsItemCarsItemMaintenanceTimePeriodMax).optional().describe('The time period in months over which this KPI target should be met'),
  "regularCallbackRate": zod.number().min(1).max(contractsCreateResponsePropertyContractsItemCarsItemRegularCallbackRateMax).optional().describe('The target regular callback rate'),
  "emergencyCallbackRate": zod.number().min(1).max(contractsCreateResponsePropertyContractsItemCarsItemEmergencyCallbackRateMax).optional().describe('The target emergency callback rate'),
  "regularCallbackResponseTime": zod.number().min(1).max(contractsCreateResponsePropertyContractsItemCarsItemRegularCallbackResponseTimeMax).optional().describe('The target regular callback response time in minutes'),
  "emergencyCallbackResponseTime": zod.number().min(1).max(contractsCreateResponsePropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax).optional().describe('The target emergency callback response time in minutes')
}).strict())
}).strict()),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsCreateResponseTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "contractPaper": zod.string(),
  "businessHours": zod.string().nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "fireService": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsCreateResponsePartsAndMaterialsMarkupRegExp).nullish(),
  "cancellation": zod.string().max(contractsCreateResponseCancellationMax).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsCreateResponseMaintenanceCompletionTargetMin).max(contractsCreateResponseMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsCreateResponseMaintenanceHoursTargetMin).max(contractsCreateResponseMaintenanceHoursTargetMax).nullish(),
  "uptimeTarget": zod.string().regex(contractsCreateResponseUptimeTargetRegExp).nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsCreateResponseOnTimeResponseTimeTargetPctRegExp).nullish(),
  "emergencyCallRateTarget": zod.number().min(contractsCreateResponseEmergencyCallRateTargetMin).max(contractsCreateResponseEmergencyCallRateTargetMax).nullish(),
  "callbackRateTarget": zod.number().min(contractsCreateResponseCallbackRateTargetMin).max(contractsCreateResponseCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsCreateResponseHourlyFeeAdjustmentRateRegExp).nullish(),
  "annualEscalationRate": zod.string().regex(contractsCreateResponseAnnualEscalationRateRegExp).nullable().describe('Compound annual escalation rate as decimal (0.03 = 3%)'),
  "monthlyPricingTaxInclusive": zod.boolean().nullable().describe('Whether monthly pricing is tax-inclusive (null = unknown)'),
  "extractionVersion": zod.string().nullable().describe('Extraction pipeline version: null=pre-pipeline, \'v0\'=original 10-page, \'v1\'=enhanced agentic'),
  "extractionAppliedAt": zod.string().datetime({"offset":true}).nullable().describe('Timestamp of the most recent successful run of apply_extraction_to_existing_contract on this contract. NULL means the contract has never been processed by the extraction-rescue helper.'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string(),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsCreateResponseReviewRulesItemCategoryDefault)
}).strict().describe('Serializer for contract review rule items in contract creation and update')),
  "notes": zod.string().nullish(),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "cars": zod.number(),
  "canChat": zod.boolean(),
  "aiReviewEligible": zod.boolean(),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsCreateResponseRateSetsItemNameMax),
  "description": zod.string().max(contractsCreateResponseRateSetsItemDescriptionMax).optional(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}),
  "rates": zod.array(zod.object({
  "id": zod.string().uuid(),
  "workType": zod.string(),
  "workerType": zod.string(),
  "rateType": zod.string(),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsCreateResponseRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsCreateResponseRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsCreateResponseRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsCreateResponseRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
}).strict()).optional()
}).strict())
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const ContractsCfiReportsListParams = zod.object({
  "contractPk": zod.string().uuid()
})

export const contractsCfiReportsListResponseFindingsItemAgentConfidenceRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,3})?$');
export const contractsCfiReportsListResponseFindingsItemAgentCitedFieldPathsItemMax = 120;



export const ContractsCfiReportsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "contract": zod.string().uuid(),
  "rubricVersion": zod.string(),
  "agentModelVersion": zod.string(),
  "mode": zod.enum(['consultant_review', 'agent_direct']).describe('\* `consultant_review` - Consultant Review\n\* `agent_direct` - Agent Direct (Solo)'),
  "status": zod.enum(['pending', 'running', 'failed', 'awaiting_review', 'published', 'superseded']).describe('\* `pending` - Pending\n\* `running` - Running\n\* `failed` - Failed\n\* `awaiting_review` - Awaiting review\n\* `published` - Published\n\* `superseded` - Superseded'),
  "triggeredByUser": zod.string().uuid().nullable(),
  "previousPublishedAt": zod.string().datetime({"offset":true}).nullable(),
  "previousPublishedByUser": zod.string().uuid().nullable(),
  "failureReason": zod.string(),
  "aggregate": zod.unknown(),
  "agentScopeSummary": zod.string(),
  "consultantScopeSummary": zod.string(),
  "finalScopeSummary": zod.string(),
  "agentNextSteps": zod.string(),
  "consultantNextSteps": zod.string(),
  "finalNextSteps": zod.string(),
  "publishedAttachment": zod.string().uuid().nullable(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedByUser": zod.string().uuid().nullable(),
  "startedAt": zod.string().datetime({"offset":true}).nullable(),
  "finishedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "findings": zod.array(zod.object({
  "id": zod.string().uuid(),
  "provisionId": zod.string(),
  "provisionLabel": zod.string(),
  "source": zod.enum(['core', 'ai_discovered', 'consultant_custom']).describe('\* `core` - Core provision\n\* `ai_discovered` - AI-discovered\n\* `consultant_custom` - Consultant custom'),
  "consultantAddedBy": zod.string().uuid().nullable(),
  "consultantAddedByName": zod.string(),
  "sortOrder": zod.number(),
  "agentRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "agentRationale": zod.string(),
  "agentSummary": zod.string(),
  "agentRecommendedAction": zod.string(),
  "agentConfidence": zod.string().regex(contractsCfiReportsListResponseFindingsItemAgentConfidenceRegExp).nullable(),
  "agentCitedChunkIds": zod.array(zod.string().uuid()),
  "agentCitedRuleIds": zod.array(zod.string().uuid()),
  "agentCitedFieldPaths": zod.array(zod.string().max(contractsCfiReportsListResponseFindingsItemAgentCitedFieldPathsItemMax)),
  "agentQualifyingLanguage": zod.unknown(),
  "agentRetrievedPrecedentIds": zod.array(zod.string().uuid()),
  "agentPrecedentDisagreement": zod.boolean(),
  "agentPrecedentDisagreementExplanation": zod.string(),
  "consultantRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "consultantRationale": zod.string(),
  "consultantSummary": zod.string(),
  "consultantRecommendedAction": zod.string(),
  "consultantEditedAt": zod.string().datetime({"offset":true}).nullable(),
  "agreedWithAgent": zod.boolean().nullable(),
  "excludedFromReport": zod.boolean(),
  "finalRating": zod.string(),
  "finalRationale": zod.string(),
  "finalSummary": zod.string(),
  "finalRecommendedAction": zod.string()
}).strict().describe('Read-only finding payload. Used by the report read endpoint and as\nthe response shape on a successful PATCH.'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const ContractsCfiReportsListResponse = zod.array(ContractsCfiReportsListResponseItem)

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const ContractsCfiReportsRetrieveParams = zod.object({
  "contractPk": zod.string().uuid(),
  "id": zod.string().uuid()
})

export const contractsCfiReportsRetrieveResponseFindingsItemAgentConfidenceRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,3})?$');
export const contractsCfiReportsRetrieveResponseFindingsItemAgentCitedFieldPathsItemMax = 120;



export const ContractsCfiReportsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "contract": zod.string().uuid(),
  "rubricVersion": zod.string(),
  "agentModelVersion": zod.string(),
  "mode": zod.enum(['consultant_review', 'agent_direct']).describe('\* `consultant_review` - Consultant Review\n\* `agent_direct` - Agent Direct (Solo)'),
  "status": zod.enum(['pending', 'running', 'failed', 'awaiting_review', 'published', 'superseded']).describe('\* `pending` - Pending\n\* `running` - Running\n\* `failed` - Failed\n\* `awaiting_review` - Awaiting review\n\* `published` - Published\n\* `superseded` - Superseded'),
  "triggeredByUser": zod.string().uuid().nullable(),
  "previousPublishedAt": zod.string().datetime({"offset":true}).nullable(),
  "previousPublishedByUser": zod.string().uuid().nullable(),
  "failureReason": zod.string(),
  "aggregate": zod.unknown(),
  "agentScopeSummary": zod.string(),
  "consultantScopeSummary": zod.string(),
  "finalScopeSummary": zod.string(),
  "agentNextSteps": zod.string(),
  "consultantNextSteps": zod.string(),
  "finalNextSteps": zod.string(),
  "publishedAttachment": zod.string().uuid().nullable(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedByUser": zod.string().uuid().nullable(),
  "startedAt": zod.string().datetime({"offset":true}).nullable(),
  "finishedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "findings": zod.array(zod.object({
  "id": zod.string().uuid(),
  "provisionId": zod.string(),
  "provisionLabel": zod.string(),
  "source": zod.enum(['core', 'ai_discovered', 'consultant_custom']).describe('\* `core` - Core provision\n\* `ai_discovered` - AI-discovered\n\* `consultant_custom` - Consultant custom'),
  "consultantAddedBy": zod.string().uuid().nullable(),
  "consultantAddedByName": zod.string(),
  "sortOrder": zod.number(),
  "agentRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "agentRationale": zod.string(),
  "agentSummary": zod.string(),
  "agentRecommendedAction": zod.string(),
  "agentConfidence": zod.string().regex(contractsCfiReportsRetrieveResponseFindingsItemAgentConfidenceRegExp).nullable(),
  "agentCitedChunkIds": zod.array(zod.string().uuid()),
  "agentCitedRuleIds": zod.array(zod.string().uuid()),
  "agentCitedFieldPaths": zod.array(zod.string().max(contractsCfiReportsRetrieveResponseFindingsItemAgentCitedFieldPathsItemMax)),
  "agentQualifyingLanguage": zod.unknown(),
  "agentRetrievedPrecedentIds": zod.array(zod.string().uuid()),
  "agentPrecedentDisagreement": zod.boolean(),
  "agentPrecedentDisagreementExplanation": zod.string(),
  "consultantRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "consultantRationale": zod.string(),
  "consultantSummary": zod.string(),
  "consultantRecommendedAction": zod.string(),
  "consultantEditedAt": zod.string().datetime({"offset":true}).nullable(),
  "agreedWithAgent": zod.boolean().nullable(),
  "excludedFromReport": zod.boolean(),
  "finalRating": zod.string(),
  "finalRationale": zod.string(),
  "finalSummary": zod.string(),
  "finalRecommendedAction": zod.string()
}).strict().describe('Read-only finding payload. Used by the report read endpoint and as\nthe response shape on a successful PATCH.'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const ContractsCfiRunCreateParams = zod.object({
  "contractPk": zod.string().uuid()
})

export const contractsCfiRunCreateResponseFindingsItemAgentConfidenceRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,3})?$');
export const contractsCfiRunCreateResponseFindingsItemAgentCitedFieldPathsItemMax = 120;



export const ContractsCfiRunCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "contract": zod.string().uuid(),
  "rubricVersion": zod.string(),
  "agentModelVersion": zod.string(),
  "mode": zod.enum(['consultant_review', 'agent_direct']).describe('\* `consultant_review` - Consultant Review\n\* `agent_direct` - Agent Direct (Solo)'),
  "status": zod.enum(['pending', 'running', 'failed', 'awaiting_review', 'published', 'superseded']).describe('\* `pending` - Pending\n\* `running` - Running\n\* `failed` - Failed\n\* `awaiting_review` - Awaiting review\n\* `published` - Published\n\* `superseded` - Superseded'),
  "triggeredByUser": zod.string().uuid().nullable(),
  "previousPublishedAt": zod.string().datetime({"offset":true}).nullable(),
  "previousPublishedByUser": zod.string().uuid().nullable(),
  "failureReason": zod.string(),
  "aggregate": zod.unknown(),
  "agentScopeSummary": zod.string(),
  "consultantScopeSummary": zod.string(),
  "finalScopeSummary": zod.string(),
  "agentNextSteps": zod.string(),
  "consultantNextSteps": zod.string(),
  "finalNextSteps": zod.string(),
  "publishedAttachment": zod.string().uuid().nullable(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedByUser": zod.string().uuid().nullable(),
  "startedAt": zod.string().datetime({"offset":true}).nullable(),
  "finishedAt": zod.string().datetime({"offset":true}).nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "findings": zod.array(zod.object({
  "id": zod.string().uuid(),
  "provisionId": zod.string(),
  "provisionLabel": zod.string(),
  "source": zod.enum(['core', 'ai_discovered', 'consultant_custom']).describe('\* `core` - Core provision\n\* `ai_discovered` - AI-discovered\n\* `consultant_custom` - Consultant custom'),
  "consultantAddedBy": zod.string().uuid().nullable(),
  "consultantAddedByName": zod.string(),
  "sortOrder": zod.number(),
  "agentRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "agentRationale": zod.string(),
  "agentSummary": zod.string(),
  "agentRecommendedAction": zod.string(),
  "agentConfidence": zod.string().regex(contractsCfiRunCreateResponseFindingsItemAgentConfidenceRegExp).nullable(),
  "agentCitedChunkIds": zod.array(zod.string().uuid()),
  "agentCitedRuleIds": zod.array(zod.string().uuid()),
  "agentCitedFieldPaths": zod.array(zod.string().max(contractsCfiRunCreateResponseFindingsItemAgentCitedFieldPathsItemMax)),
  "agentQualifyingLanguage": zod.unknown(),
  "agentRetrievedPrecedentIds": zod.array(zod.string().uuid()),
  "agentPrecedentDisagreement": zod.boolean(),
  "agentPrecedentDisagreementExplanation": zod.string(),
  "consultantRating": zod.union([zod.enum(['favorable', 'neutral', 'unfavorable', 'not_applicable']).describe('\* `favorable` - Favorable\n\* `neutral` - Neutral\n\* `unfavorable` - Unfavorable\n\* `not_applicable` - Not Applicable'),zod.literal(null)]).nullable(),
  "consultantRationale": zod.string(),
  "consultantSummary": zod.string(),
  "consultantRecommendedAction": zod.string(),
  "consultantEditedAt": zod.string().datetime({"offset":true}).nullable(),
  "agreedWithAgent": zod.boolean().nullable(),
  "excludedFromReport": zod.boolean(),
  "finalRating": zod.string(),
  "finalRationale": zod.string(),
  "finalSummary": zod.string(),
  "finalRecommendedAction": zod.string()
}).strict().describe('Read-only finding payload. Used by the report read endpoint and as\nthe response shape on a successful PATCH.'))
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * GET /api/v1/contracts/{contract_pk}/chunks/?ids=<uuid>,<uuid>
 *
 * Returns the verbatim chunk text + page number for the requested ids,
 * filtered to chunks that actually belong to this contract. Powers the FE
 * evidence panel popover.
 */
export const ContractsChunksListParams = zod.object({
  "contractPk": zod.string().uuid()
})

export const ContractsChunksListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "pageNumber": zod.number().describe('1-indexed page number in the PDF'),
  "text": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const ContractsChunksListResponse = zod.array(ContractsChunksListResponseItem)

/**
 * Full API CRUD access to Contract entities.
 */
export const ContractsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})

export const contractsRetrieveResponseNameMax = 255;

export const contractsRetrieveResponseAttachmentsItemPageNumberMin = -2147483648;
export const contractsRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;

export const contractsRetrieveResponseServiceProviderOneOwnerOneUsernameMax = 150;


export const contractsRetrieveResponseServiceProviderOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const contractsRetrieveResponseServiceProviderOneOwnerOneEmailMax = 254;

export const contractsRetrieveResponseServiceProviderOneOwnerOnePhoneNumberMax = 128;

export const contractsRetrieveResponsePropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,9}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponsePropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponsePropertyContractsItemCarsItemMaintenanceTimePeriodMax = 2147483647;

export const contractsRetrieveResponsePropertyContractsItemCarsItemRegularCallbackRateMax = 2147483647;

export const contractsRetrieveResponsePropertyContractsItemCarsItemEmergencyCallbackRateMax = 2147483647;

export const contractsRetrieveResponsePropertyContractsItemCarsItemRegularCallbackResponseTimeMax = 2147483647;

export const contractsRetrieveResponsePropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax = 2147483647;

export const contractsRetrieveResponseTermMax = 50;

export const contractsRetrieveResponsePartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponseCancellationMax = 255;

export const contractsRetrieveResponseMaintenanceCompletionTargetMin = 0;
export const contractsRetrieveResponseMaintenanceCompletionTargetMax = 2147483647;

export const contractsRetrieveResponseMaintenanceHoursTargetMin = 0;
export const contractsRetrieveResponseMaintenanceHoursTargetMax = 2147483647;

export const contractsRetrieveResponseUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponseOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponseEmergencyCallRateTargetMin = 0;
export const contractsRetrieveResponseEmergencyCallRateTargetMax = 2147483647;

export const contractsRetrieveResponseCallbackRateTargetMin = 0;
export const contractsRetrieveResponseCallbackRateTargetMax = 2147483647;

export const contractsRetrieveResponseHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponseAnnualEscalationRateRegExp = new RegExp('^-?\\d{0,1}(?:\\.\\d{0,4})?$');
export const contractsRetrieveResponseReviewRulesItemCategoryDefault = `review-rule`;
export const contractsRetrieveResponseRateSetsItemNameMax = 255;

export const contractsRetrieveResponseRateSetsItemDescriptionMax = 255;

export const contractsRetrieveResponseRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsRetrieveResponseRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsRetrieveResponseRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsRetrieveResponseRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const ContractsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsRetrieveResponseNameMax),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "name": zod.string(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "pageNumber": zod.number().min(contractsRetrieveResponseAttachmentsItemPageNumberMin).max(contractsRetrieveResponseAttachmentsItemPageNumberMax).nullish(),
  "isSummarySheet": zod.boolean().optional(),
  "kind": zod.enum(['user_upload', 'cfi_report']).describe('\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report').optional().describe('What this attachment represents on the contract. user_upload is anything a user (or upstream pipeline) attaches; cfi_report marks a Contract Favorability Index PDF generated by the agent.\n\n\* `user_upload` - User Upload\n\* `cfi_report` - CFI Report'),
  "uploadedAt": zod.string().datetime({"offset":true}),
  "hasTextLayer": zod.boolean()
}).strict()),
  "serviceProvider": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(contractsRetrieveResponseServiceProviderOneOwnerOneUsernameMax).regex(contractsRetrieveResponseServiceProviderOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(contractsRetrieveResponseServiceProviderOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(contractsRetrieveResponseServiceProviderOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "propertyAddress": zod.string().nullable(),
  "monthlyPrice": zod.string().regex(contractsRetrieveResponsePropertyContractsItemMonthlyPriceRegExp).nullish().describe('Monthly price specific to this property under this contract'),
  "startDate": zod.string().date().nullish().describe('Start date for this specific property under the contract'),
  "expirationDate": zod.string().date().nullish().describe('Expiration date for this specific property under the contract'),
  "rateSet": zod.string().uuid().nullish(),
  "contractId": zod.string().uuid(),
  "rateSetId": zod.string().uuid().nullable(),
  "carCount": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "carId": zod.string().uuid(),
  "name": zod.string(),
  "maintenanceQuantity": zod.string().regex(contractsRetrieveResponsePropertyContractsItemCarsItemMaintenanceQuantityRegExp).optional().describe('The target quantity for this KPI'),
  "maintenanceUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours').optional().describe('The unit of measurement for this KPI (visits or hours)\n\n\* `visits` - Visits\n\* `hours` - Hours'),
  "maintenanceTimePeriod": zod.number().min(1).max(contractsRetrieveResponsePropertyContractsItemCarsItemMaintenanceTimePeriodMax).optional().describe('The time period in months over which this KPI target should be met'),
  "regularCallbackRate": zod.number().min(1).max(contractsRetrieveResponsePropertyContractsItemCarsItemRegularCallbackRateMax).optional().describe('The target regular callback rate'),
  "emergencyCallbackRate": zod.number().min(1).max(contractsRetrieveResponsePropertyContractsItemCarsItemEmergencyCallbackRateMax).optional().describe('The target emergency callback rate'),
  "regularCallbackResponseTime": zod.number().min(1).max(contractsRetrieveResponsePropertyContractsItemCarsItemRegularCallbackResponseTimeMax).optional().describe('The target regular callback response time in minutes'),
  "emergencyCallbackResponseTime": zod.number().min(1).max(contractsRetrieveResponsePropertyContractsItemCarsItemEmergencyCallbackResponseTimeMax).optional().describe('The target emergency callback response time in minutes')
}).strict())
}).strict()),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsRetrieveResponseTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "contractPaper": zod.string(),
  "businessHours": zod.string().nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "fireService": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsRetrieveResponsePartsAndMaterialsMarkupRegExp).nullish(),
  "cancellation": zod.string().max(contractsRetrieveResponseCancellationMax).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsRetrieveResponseMaintenanceCompletionTargetMin).max(contractsRetrieveResponseMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsRetrieveResponseMaintenanceHoursTargetMin).max(contractsRetrieveResponseMaintenanceHoursTargetMax).nullish(),
  "uptimeTarget": zod.string().regex(contractsRetrieveResponseUptimeTargetRegExp).nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsRetrieveResponseOnTimeResponseTimeTargetPctRegExp).nullish(),
  "emergencyCallRateTarget": zod.number().min(contractsRetrieveResponseEmergencyCallRateTargetMin).max(contractsRetrieveResponseEmergencyCallRateTargetMax).nullish(),
  "callbackRateTarget": zod.number().min(contractsRetrieveResponseCallbackRateTargetMin).max(contractsRetrieveResponseCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsRetrieveResponseHourlyFeeAdjustmentRateRegExp).nullish(),
  "annualEscalationRate": zod.string().regex(contractsRetrieveResponseAnnualEscalationRateRegExp).nullable().describe('Compound annual escalation rate as decimal (0.03 = 3%)'),
  "monthlyPricingTaxInclusive": zod.boolean().nullable().describe('Whether monthly pricing is tax-inclusive (null = unknown)'),
  "extractionVersion": zod.string().nullable().describe('Extraction pipeline version: null=pre-pipeline, \'v0\'=original 10-page, \'v1\'=enhanced agentic'),
  "extractionAppliedAt": zod.string().datetime({"offset":true}).nullable().describe('Timestamp of the most recent successful run of apply_extraction_to_existing_contract on this contract. NULL means the contract has never been processed by the extraction-rescue helper.'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string(),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsRetrieveResponseReviewRulesItemCategoryDefault)
}).strict().describe('Serializer for contract review rule items in contract creation and update')),
  "notes": zod.string().nullish(),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "cars": zod.number(),
  "canChat": zod.boolean(),
  "aiReviewEligible": zod.boolean(),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(contractsRetrieveResponseRateSetsItemNameMax),
  "description": zod.string().max(contractsRetrieveResponseRateSetsItemDescriptionMax).optional(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}),
  "rates": zod.array(zod.object({
  "id": zod.string().uuid(),
  "workType": zod.string(),
  "workerType": zod.string(),
  "rateType": zod.string(),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsRetrieveResponseRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsRetrieveResponseRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsRetrieveResponseRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsRetrieveResponseRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
}).strict()).optional()
}).strict())
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Full API CRUD access to Contract entities.
 */
export const ContractsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})

export const contractsUpdateBodyAttachmentsItemIsPrimaryDefault = false;
export const contractsUpdateBodyAttachmentsItemIsSummarySheetDefault = false;
export const contractsUpdateBodyCallbackRateTargetMin = 0;
export const contractsUpdateBodyCallbackRateTargetMax = 2147483647;

export const contractsUpdateBodyCancellationMax = 255;

export const contractsUpdateBodyContractPaperMax = 255;

export const contractsUpdateBodyEmergencyCallRateTargetMin = 0;
export const contractsUpdateBodyEmergencyCallRateTargetMax = 2147483647;

export const contractsUpdateBodyHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateBodyMaintenanceCompletionTargetMin = 0;
export const contractsUpdateBodyMaintenanceCompletionTargetMax = 2147483647;

export const contractsUpdateBodyMaintenanceHoursTargetMin = 0;
export const contractsUpdateBodyMaintenanceHoursTargetMax = 2147483647;

export const contractsUpdateBodyNameMax = 255;

export const contractsUpdateBodyOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateBodyPartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateBodyPropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsUpdateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsUpdateBodyRateSetsItemNameMax = 255;

export const contractsUpdateBodyRateSetsItemDescriptionMax = 255;




export const contractsUpdateBodyRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsUpdateBodyRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsUpdateBodyRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsUpdateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsUpdateBodyReviewRulesItemCategoryDefault = `review-rule`;
export const contractsUpdateBodyTermMax = 50;

export const contractsUpdateBodyUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');


export const ContractsUpdateBody = zod.object({
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "isPrimary": zod.boolean().default(contractsUpdateBodyAttachmentsItemIsPrimaryDefault),
  "pageNumber": zod.number().nullish(),
  "isSummarySheet": zod.boolean().default(contractsUpdateBodyAttachmentsItemIsSummarySheetDefault)
}).describe('Serializer for attachment data in contract creation')).optional().describe('List of attachments with their properties to associate with this contract'),
  "businessHours": zod.string().nullish(),
  "callbackRateTarget": zod.number().min(contractsUpdateBodyCallbackRateTargetMin).max(contractsUpdateBodyCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "cancellation": zod.string().max(contractsUpdateBodyCancellationMax).nullish(),
  "contractPaper": zod.string().min(1).max(contractsUpdateBodyContractPaperMax),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "emergencyCallRateTarget": zod.number().min(contractsUpdateBodyEmergencyCallRateTargetMin).max(contractsUpdateBodyEmergencyCallRateTargetMax).nullish(),
  "expirationDate": zod.string().date().nullish(),
  "fireService": zod.boolean().nullish(),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsUpdateBodyHourlyFeeAdjustmentRateRegExp).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsUpdateBodyMaintenanceCompletionTargetMin).max(contractsUpdateBodyMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsUpdateBodyMaintenanceHoursTargetMin).max(contractsUpdateBodyMaintenanceHoursTargetMax).nullish(),
  "name": zod.string().min(1).max(contractsUpdateBodyNameMax),
  "notes": zod.string().nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsUpdateBodyOnTimeResponseTimeTargetPctRegExp).nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsUpdateBodyPartsAndMaterialsMarkupRegExp).nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(contractsUpdateBodyPropertyContractsItemMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(contractsUpdateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})).optional().describe('Property contracts to create or update with this contract'),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1).max(contractsUpdateBodyRateSetsItemNameMax),
  "description": zod.string().max(contractsUpdateBodyRateSetsItemDescriptionMax).optional(),
  "isNew": zod.boolean(),
  "rates": zod.array(zod.object({
  "workType": zod.string().min(1),
  "workerType": zod.string().min(1),
  "rateType": zod.string().min(1),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsUpdateBodyRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsUpdateBodyRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsUpdateBodyRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsUpdateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
})).optional()
})).optional().describe('Rate sets to create with this contract'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string().min(1),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsUpdateBodyReviewRulesItemCategoryDefault)
}).describe('Serializer for contract review rule items in contract creation and update')).optional().describe('Review rules to create with this contract'),
  "serviceProvider": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsUpdateBodyTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "uptimeTarget": zod.string().regex(contractsUpdateBodyUptimeTargetRegExp).nullish()
}).describe('Serializer for creating and updating contracts')

export const contractsUpdateResponseCallbackRateTargetMin = 0;
export const contractsUpdateResponseCallbackRateTargetMax = 2147483647;

export const contractsUpdateResponseCancellationMax = 255;

export const contractsUpdateResponseContractPaperMax = 255;

export const contractsUpdateResponseEmergencyCallRateTargetMin = 0;
export const contractsUpdateResponseEmergencyCallRateTargetMax = 2147483647;

export const contractsUpdateResponseHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateResponseMaintenanceCompletionTargetMin = 0;
export const contractsUpdateResponseMaintenanceCompletionTargetMax = 2147483647;

export const contractsUpdateResponseMaintenanceHoursTargetMin = 0;
export const contractsUpdateResponseMaintenanceHoursTargetMax = 2147483647;

export const contractsUpdateResponseNameMax = 255;

export const contractsUpdateResponseOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateResponsePartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsUpdateResponseTermMax = 50;

export const contractsUpdateResponseUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');


export const ContractsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "businessHours": zod.string().nullish(),
  "callbackRateTarget": zod.number().min(contractsUpdateResponseCallbackRateTargetMin).max(contractsUpdateResponseCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "cancellation": zod.string().max(contractsUpdateResponseCancellationMax).nullish(),
  "contractPaper": zod.string().max(contractsUpdateResponseContractPaperMax),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "emergencyCallRateTarget": zod.number().min(contractsUpdateResponseEmergencyCallRateTargetMin).max(contractsUpdateResponseEmergencyCallRateTargetMax).nullish(),
  "expirationDate": zod.string().date().nullish(),
  "fireService": zod.boolean().nullish(),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsUpdateResponseHourlyFeeAdjustmentRateRegExp).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsUpdateResponseMaintenanceCompletionTargetMin).max(contractsUpdateResponseMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsUpdateResponseMaintenanceHoursTargetMin).max(contractsUpdateResponseMaintenanceHoursTargetMax).nullish(),
  "name": zod.string().max(contractsUpdateResponseNameMax),
  "notes": zod.string().nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsUpdateResponseOnTimeResponseTimeTargetPctRegExp).nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsUpdateResponsePartsAndMaterialsMarkupRegExp).nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "serviceProvider": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsUpdateResponseTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "uptimeTarget": zod.string().regex(contractsUpdateResponseUptimeTargetRegExp).nullish()
}).strict().describe('Serializer for creating and updating contracts')

/**
 * Full API CRUD access to Contract entities.
 */
export const ContractsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})

export const contractsPartialUpdateBodyAttachmentsItemIsPrimaryDefault = false;
export const contractsPartialUpdateBodyAttachmentsItemIsSummarySheetDefault = false;
export const contractsPartialUpdateBodyCallbackRateTargetMin = 0;
export const contractsPartialUpdateBodyCallbackRateTargetMax = 2147483647;

export const contractsPartialUpdateBodyCancellationMax = 255;

export const contractsPartialUpdateBodyContractPaperMax = 255;

export const contractsPartialUpdateBodyEmergencyCallRateTargetMin = 0;
export const contractsPartialUpdateBodyEmergencyCallRateTargetMax = 2147483647;

export const contractsPartialUpdateBodyHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateBodyMaintenanceCompletionTargetMin = 0;
export const contractsPartialUpdateBodyMaintenanceCompletionTargetMax = 2147483647;

export const contractsPartialUpdateBodyMaintenanceHoursTargetMin = 0;
export const contractsPartialUpdateBodyMaintenanceHoursTargetMax = 2147483647;

export const contractsPartialUpdateBodyNameMax = 255;

export const contractsPartialUpdateBodyOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateBodyPartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateBodyPropertyContractsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsPartialUpdateBodyRateSetsItemNameMax = 255;

export const contractsPartialUpdateBodyRateSetsItemDescriptionMax = 255;




export const contractsPartialUpdateBodyRateSetsItemRatesItemCoverageTypeDefault = `billable`;
export const contractsPartialUpdateBodyRateSetsItemRatesItemHourlyRateRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateBodyRateSetsItemRatesItemIsDefaultDefault = false;
export const contractsPartialUpdateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');

export const contractsPartialUpdateBodyReviewRulesItemCategoryDefault = `review-rule`;
export const contractsPartialUpdateBodyTermMax = 50;

export const contractsPartialUpdateBodyUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');


export const ContractsPartialUpdateBody = zod.object({
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "isPrimary": zod.boolean().default(contractsPartialUpdateBodyAttachmentsItemIsPrimaryDefault),
  "pageNumber": zod.number().nullish(),
  "isSummarySheet": zod.boolean().default(contractsPartialUpdateBodyAttachmentsItemIsSummarySheetDefault)
}).describe('Serializer for attachment data in contract creation')).optional().describe('List of attachments with their properties to associate with this contract'),
  "businessHours": zod.string().nullish(),
  "callbackRateTarget": zod.number().min(contractsPartialUpdateBodyCallbackRateTargetMin).max(contractsPartialUpdateBodyCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "cancellation": zod.string().max(contractsPartialUpdateBodyCancellationMax).nullish(),
  "contractPaper": zod.string().min(1).max(contractsPartialUpdateBodyContractPaperMax).optional(),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "emergencyCallRateTarget": zod.number().min(contractsPartialUpdateBodyEmergencyCallRateTargetMin).max(contractsPartialUpdateBodyEmergencyCallRateTargetMax).nullish(),
  "expirationDate": zod.string().date().nullish(),
  "fireService": zod.boolean().nullish(),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsPartialUpdateBodyHourlyFeeAdjustmentRateRegExp).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsPartialUpdateBodyMaintenanceCompletionTargetMin).max(contractsPartialUpdateBodyMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsPartialUpdateBodyMaintenanceHoursTargetMin).max(contractsPartialUpdateBodyMaintenanceHoursTargetMax).nullish(),
  "name": zod.string().min(1).max(contractsPartialUpdateBodyNameMax).optional(),
  "notes": zod.string().nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsPartialUpdateBodyOnTimeResponseTimeTargetPctRegExp).nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsPartialUpdateBodyPartsAndMaterialsMarkupRegExp).nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "propertyContracts": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(contractsPartialUpdateBodyPropertyContractsItemMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(contractsPartialUpdateBodyPropertyContractsItemCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})).optional().describe('Property contracts to create or update with this contract'),
  "rateSets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1).max(contractsPartialUpdateBodyRateSetsItemNameMax),
  "description": zod.string().max(contractsPartialUpdateBodyRateSetsItemDescriptionMax).optional(),
  "isNew": zod.boolean(),
  "rates": zod.array(zod.object({
  "workType": zod.string().min(1),
  "workerType": zod.string().min(1),
  "rateType": zod.string().min(1),
  "coverageType": zod.enum(['fully-covered', 'premium-only', 'billable']).describe('\* `fully-covered` - Fully Covered\n\* `premium-only` - Premium Only\n\* `billable` - Billable').default(contractsPartialUpdateBodyRateSetsItemRatesItemCoverageTypeDefault),
  "hourlyRate": zod.string().regex(contractsPartialUpdateBodyRateSetsItemRatesItemHourlyRateRegExp),
  "isDefault": zod.boolean().default(contractsPartialUpdateBodyRateSetsItemRatesItemIsDefaultDefault),
  "description": zod.string().optional(),
  "rateSetId": zod.string().uuid().optional(),
  "overtimeMultiplier": zod.string().regex(contractsPartialUpdateBodyRateSetsItemRatesItemOvertimeMultiplierRegExp).nullish()
})).optional()
})).optional().describe('Rate sets to create with this contract'),
  "reviewRules": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string().min(1),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsPartialUpdateBodyReviewRulesItemCategoryDefault)
}).describe('Serializer for contract review rule items in contract creation and update')).optional().describe('Review rules to create with this contract'),
  "serviceProvider": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsPartialUpdateBodyTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).optional().describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "uptimeTarget": zod.string().regex(contractsPartialUpdateBodyUptimeTargetRegExp).nullish()
}).describe('Serializer for creating and updating contracts')

export const contractsPartialUpdateResponseCallbackRateTargetMin = 0;
export const contractsPartialUpdateResponseCallbackRateTargetMax = 2147483647;

export const contractsPartialUpdateResponseCancellationMax = 255;

export const contractsPartialUpdateResponseContractPaperMax = 255;

export const contractsPartialUpdateResponseEmergencyCallRateTargetMin = 0;
export const contractsPartialUpdateResponseEmergencyCallRateTargetMax = 2147483647;

export const contractsPartialUpdateResponseHourlyFeeAdjustmentRateRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateResponseMaintenanceCompletionTargetMin = 0;
export const contractsPartialUpdateResponseMaintenanceCompletionTargetMax = 2147483647;

export const contractsPartialUpdateResponseMaintenanceHoursTargetMin = 0;
export const contractsPartialUpdateResponseMaintenanceHoursTargetMax = 2147483647;

export const contractsPartialUpdateResponseNameMax = 255;

export const contractsPartialUpdateResponseOnTimeResponseTimeTargetPctRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateResponsePartsAndMaterialsMarkupRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');
export const contractsPartialUpdateResponseTermMax = 50;

export const contractsPartialUpdateResponseUptimeTargetRegExp = new RegExp('^-?\\d{0,3}(?:\\.\\d{0,2})?$');


export const ContractsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "businessHours": zod.string().nullish(),
  "callbackRateTarget": zod.number().min(contractsPartialUpdateResponseCallbackRateTargetMin).max(contractsPartialUpdateResponseCallbackRateTargetMax).nullish().describe('Target number of callbacks per car per year'),
  "cancellation": zod.string().max(contractsPartialUpdateResponseCancellationMax).nullish(),
  "contractPaper": zod.string().max(contractsPartialUpdateResponseContractPaperMax),
  "customDetails": zod.unknown().optional().describe('Free-form summary items shown on the contract details view. Stored as a list of {name, label, value} objects.'),
  "emergencyCallRateTarget": zod.number().min(contractsPartialUpdateResponseEmergencyCallRateTargetMin).max(contractsPartialUpdateResponseEmergencyCallRateTargetMax).nullish(),
  "expirationDate": zod.string().date().nullish(),
  "fireService": zod.boolean().nullish(),
  "hourlyFeeAdjustmentRate": zod.string().regex(contractsPartialUpdateResponseHourlyFeeAdjustmentRateRegExp).nullish(),
  "maintenanceCompletionTarget": zod.number().min(contractsPartialUpdateResponseMaintenanceCompletionTargetMin).max(contractsPartialUpdateResponseMaintenanceCompletionTargetMax).nullish(),
  "maintenanceHoursTarget": zod.number().min(contractsPartialUpdateResponseMaintenanceHoursTargetMin).max(contractsPartialUpdateResponseMaintenanceHoursTargetMax).nullish(),
  "name": zod.string().max(contractsPartialUpdateResponseNameMax),
  "notes": zod.string().nullish(),
  "onTimeResponseTimeTargetPct": zod.string().regex(contractsPartialUpdateResponseOnTimeResponseTimeTargetPctRegExp).nullish(),
  "partsAndMaterialsMarkup": zod.string().regex(contractsPartialUpdateResponsePartsAndMaterialsMarkupRegExp).nullish(),
  "phoneMonitoring": zod.boolean().nullish(),
  "pressureTest": zod.boolean().nullish(),
  "serviceProvider": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "term": zod.string().max(contractsPartialUpdateResponseTermMax).optional(),
  "type": zod.enum(['24/7', 'standard', 'standard-ot-differential', 'platinum-ot-differential', 'other']).describe('\* `24\/7` - 24\/7\n\* `standard` - Standard\n\* `standard-ot-differential` - Standard-OT Differential\n\* `platinum-ot-differential` - Platinum-OT Differential\n\* `other` - Other'),
  "uptimeTarget": zod.string().regex(contractsPartialUpdateResponseUptimeTargetRegExp).nullish()
}).strict().describe('Serializer for creating and updating contracts')

/**
 * Full API CRUD access to Contract entities.
 */
export const ContractsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})

export const ContractsDestroyResponse = zod.void()

/**
 * End a contract
 */
export const ContractsEndCreateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})

export const ContractsEndCreateBody = zod.object({
  "endDate": zod.string().date()
}).describe('Request body for POST \/contracts\/{id}\/end\/.\n\nDrives both the OpenAPI request shape and runtime validation: the `end`\naction validates against this serializer so a missing\/malformed end_date is\nrejected instead of silently nulling the contract\'s expiration_date.')

export const ContractsEndCreateResponse = zod.void()

/**
 * Append a single review rule to a contract.
 *
 * Atomic single-rule create, used by the AI-vs-consultant rule-suggestion
 * flow. Unlike the full contract PATCH (which replaces the whole
 * review_rules array), this only adds — it never updates or deletes
 * existing rules.
 */
export const ContractsReviewRulesCreateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this contract.')
})


export const contractsReviewRulesCreateBodyCategoryDefault = `review-rule`;

export const ContractsReviewRulesCreateBody = zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string().min(1),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsReviewRulesCreateBodyCategoryDefault)
}).describe('Serializer for contract review rule items in contract creation and update')

export const contractsReviewRulesCreateResponseCategoryDefault = `review-rule`;

export const ContractsReviewRulesCreateResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "reviewRule": zod.string(),
  "category": zod.enum(['review-rule', 'included-service', 'excluded-service', 'miscellaneous-charge', 'other-term']).describe('\* `review-rule` - Review Rule\n\* `included-service` - Included Service\n\* `excluded-service` - Excluded Service\n\* `miscellaneous-charge` - Miscellaneous Charge\n\* `other-term` - Other Term').default(contractsReviewRulesCreateResponseCategoryDefault)
}).strict().describe('Serializer for contract review rule items in contract creation and update')

